import React from 'react';
import { TableRow, TableCell, Chip } from '@mui/material';
import { colors, fonts, tableStyles } from '../../constants';
import { getStatusColor, getPriorityColor } from '../../utils/slaDashboardUtils';

/**
 * SLATableRow Component
 * Individual query row in table
 */
const SLATableRow = ({ query }) => {
  return (
    <TableRow key={query.id} hover sx={{ '&:hover': { backgroundColor: colors.backgroundLight } }}>
      <TableCell sx={{ ...tableStyles.cell }}>{query.id}</TableCell>
      <TableCell sx={{ ...tableStyles.cell }}>
        <Chip
          label={query.priority}
          size="small"
          sx={{
            backgroundColor: getPriorityColor(query.priority) + '20',
            color: getPriorityColor(query.priority),
            fontWeight: fonts.weightSemiBold,
            fontSize: fonts.fontSizeXs,
          }}
        />
      </TableCell>
      <TableCell sx={{ ...tableStyles.cell }}>{query.project}</TableCell>
      <TableCell sx={{ ...tableStyles.cell }}>
        <Chip
          label={query.status}
          size="small"
          sx={{
            backgroundColor: getStatusColor(query.status) + '20',
            color: getStatusColor(query.status),
            fontWeight: fonts.weightSemiBold,
            fontSize: fonts.fontSizeXs,
          }}
        />
      </TableCell>
      <TableCell sx={{ ...tableStyles.cell }}>{query.slaDue}</TableCell>
      <TableCell
        sx={{
          ...tableStyles.cell,
          color: query.status === 'Breached' ? colors.error : query.status === 'At Risk' ? colors.warning : colors.textSecondary,
          fontWeight: query.status === 'Breached' || query.status === 'At Risk' ? fonts.weightSemiBold : fonts.weightNormal,
        }}
      >
        {query.timeRemaining}
      </TableCell>
      <TableCell sx={{ ...tableStyles.cell }}>{query.responseTime}</TableCell>
    </TableRow>
  );
};

export default SLATableRow;
